import { Link } from "react-router-dom";
import { creators } from "@/mocks/creators";

const tickerItems = [
  { name: "甜栗子", score: 92 },
  { name: "海盐可可", score: 88 },
  { name: "阿夜 NIGHT", score: 86 },
  { name: "山野阿栗", score: 90 },
  { name: "一颗青柠", score: 84 },
  { name: "拾光少女", score: 81 },
  { name: "白桃乌龙", score: 77 },
  { name: "橘子汽水", score: 74 },
  { name: "毛豆先生", score: 71 },
  { name: "老周说书", score: 68 },
];

export default function Ticker() {
  const topThree = [...creators].sort((a, b) => b.heat - a.heat).slice(0, 3);

  return (
    <>
      <div className="w-full overflow-hidden border-b border-background-200 bg-foreground-950 py-3">
        <div className="flex w-max fc-marquee">
          {[0, 1].map((loop) => (
            <div key={loop} className="flex shrink-0 items-center">
              {tickerItems.map((item) => (
                <span
                  key={`${loop}-${item.name}`}
                  className="flex items-center gap-2 whitespace-nowrap px-6 text-xs text-background-100"
                >
                  <i className="ri-arrow-up-double-line text-accent-400"></i>
                  {item.name}
                  <span className="text-accent-300">反差指数 {item.score}</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <section
        aria-label="热门对比推荐"
        className="w-full border-b border-background-200 bg-background-100"
      >
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-4 px-4 py-5 md:flex-row md:items-center md:justify-between md:px-8">
          <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
            今日热度最高的三组对比
          </h2>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {topThree.map((creator, index) => (
              <li key={creator.slug} className="flex items-center gap-2">
                <span className="font-heading text-sm font-bold text-primary-500">
                  0{index + 1}
                </span>
                <Link
                  to={`/detail/${creator.slug}`}
                  className="cursor-pointer whitespace-nowrap text-sm text-foreground-800 transition-colors hover:text-primary-600"
                >
                  {creator.name}
                </Link>
                <span className="text-xs text-foreground-500">{creator.category}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}